import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import SVGLayer from './SVGLayer'
import Description from './Description'
import LayerContent from '../../LayerContent'

const GroundWater = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) => (
        <SVGLayer active={active} setActiveProject={setActiveProject} />
      )}
    </LayerContent>
  )
}

GroundWater.propTypes = {
  location: PropTypes.object
}

export { Description as GroundWaterDescription }

export default withRouter(GroundWater)
